<div class="showtime-cinema-wrapper new-flow">
  <a
    #mapTrigger
    class="showtime-cinema trigger ush-cinema"
    (click)="openMap()"
    (keyup)="openMapKey($event)"
    role="button"
    tabindex="0"
  >
    <div class="showtime-cinema-info">
      <img
        class="ush-cinema-logo"
        [src]="performance.cinema.imageUrl | img: { placeholder: defaultCinemaPlaceholder }"
        [alt]="performance.cinema.name"
        (error)="handleCinemaErrorImg($event)"
      />
      <div>
        <div class="showtime-text-info">
          <span class="ush-cinema-name" [title]="performance?.cinema?.name">
            {{ performance?.cinema?.name }}
          </span>
          @if (performance?.distanceLiteral) {
            <span class="distance-literal">
              {{ ' (' + performance?.distanceLiteral + ')' }}
            </span>
          }
        </div>
        <!--!NOTE This part is redundant with the "cinema-location" in "ush-performance"-->
        <div class="ush-cinema-info">
          <fa-icon [icon]="markerIcon" class="map-icon ush-cinema-map-icon"></fa-icon>
          <span class="ush-cinema-address" [title]="performance?.cinema?.place?.address">
            {{ performance?.cinema?.place?.address ? performance.cinema.place.address + ',' : '' }} {{ performance?.cinema?.place?.city?.name }}
          </span>
        </div>
      </div>
    </div>
  </a>
  <showtime-streaming-map [perfGroup]="performance" />
</div>
